var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarksIconBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.09375 7.60625H5.04375V7.65625V10.7312H3.58125V5.3125C3.58125 4.04777 4.61027 3.01875 5.875 3.01875C7.13973 3.01875 8.16875 4.04777 8.16875 5.3125V10.7312H6.70625V7.65625V7.60625H6.65625H5.09375ZM6.65625 6.14375H6.70625V6.09375V5.3125C6.70625 4.8541 6.3334 4.48125 5.875 4.48125C5.4166 4.48125 5.04375 4.8541 5.04375 5.3125V6.09375V6.14375H5.09375H6.65625ZM12.9062 6.04375H12.8562V6.09375V7.60625H11.3938V6.09375V6.04375H11.3438H9.83125V4.58125H11.3438H11.3938V4.53125V3.01875H12.8562V4.53125V4.58125H12.9062H14.4187V6.04375H12.9062ZM16.0312 18.4875H16.0813V18.4375V1.5625V1.5125H16.0312H1.96875H1.91875V1.5625V18.4375V18.4875H1.96875H16.0312ZM0.45625 19.95V0.05H17.5438V19.95H0.45625ZM3.58125 12.3938H14.4187V13.8562H3.58125V12.3938ZM3.58125 15.5188H14.4187V16.9813H3.58125V15.5188Z",
    fill: "#2667B0",
    stroke: "white",
    strokeWidth: 0.1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarksIconBlue);
export default __webpack_public_path__ + "static/media/marks_icon_blue.c66337ae190e0d5529cf8c35c75311bc.svg";
export { ForwardRef as ReactComponent };